<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Add Tournament</h4>
      </div>
      <div class="modal-body">
        <div class="row mb-3">
          <div class="col-sm-6">
            <label>Type</label>
            <select class="form-control" [(ngModel)]="type">
              @for (t of tournamentTypes; track t[1]) {
                <option [ngValue]="t[1]">{{ t[0] }}</option>
              }
            </select>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-6">
            <label>Start Date</label>
            <input class="form-control" [(ngModel)]="startDate" type="datetime-local">
          </div>
          <div class="col-sm-6">
            <label>End Date</label>
            <input class="form-control" [(ngModel)]="endDate" type="datetime-local">
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-6">
            <label>Cost Quantity</label>
            <input class="form-control" [(ngModel)]="costQuantity" type="number" min="0">
          </div>
          <div class="col-sm-6">
            <label>Reward Total Quantity</label>
            <input class="form-control" [(ngModel)]="rewardTotalQuantity" type="number" min="0">
          </div>
        </div>

        <hr/>
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h6 class="mb-0">Rewards</h6>
          <button type="button" class="btn btn-sm btn-success" (click)="addReward()"><i class="fa fa-plus"></i> Add Reward</button>
        </div>
        @for (r of rewards; track $index; let i = $index) {
          <div class="card mb-2">
            <div class="card-body">
              <div class="d-flex justify-content-end mb-2">
                <button type="button" class="btn btn-sm btn-danger" (click)="removeReward(i)"><i class="fa fa-trash"></i></button>
              </div>
              <div class="row">
                <div class="col-sm-4 mb-2">
                  <label>Range Min</label>
                  <input class="form-control" [(ngModel)]="r.rangeMin" type="number" min="1">
                </div>
                <div class="col-sm-4 mb-2">
                  <label>Range Max</label>
                  <input class="form-control" [(ngModel)]="r.rangeMax" type="number" min="1">
                </div>
                <div class="col-sm-4 mb-0">
                  <label>Reward Quantity</label>
                  <input class="form-control" [(ngModel)]="r.rewardQuantity" type="number" min="0">
                </div>
              </div>
            </div>
          </div>
        }
        @if (rewards.length === 0) { <p class="text-muted small">No rewards.</p> }
      </div>
      <div class="modal-footer">
        <button [disabled]="isLoading" type="button" class="btn btn-secondary" (click)="modal.hide()">Cancel</button>
        <button [disabled]="isLoading" type="button" class="btn btn-primary" (click)="save()">
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
          Add
        </button>
      </div>
    </div>
  </div>
</div>
